import { GetLoyaltyCollectionByIdProductsResponseDto } from '@src/api';

import { LoyaltyProgramListProduct } from '../../models';

export const productApiToProductUI = (
  apiProduct: GetLoyaltyCollectionByIdProductsResponseDto,
): LoyaltyProgramListProduct => {
  return {
    id: apiProduct.id,
    name: apiProduct.name,
    unionId: apiProduct.parentOrganisationId,
    discountText: apiProduct.discountText ?? '',
    coverImageId: apiProduct.coverPhotoId,
  };
};
